const Lang = require('lang');

function ResetAccount() {
  const btnReset = document.querySelector('#reset-account');
  nifty.body.overlay({
    fixed: true
  });

  if (btnReset !== null) {
    $(btnReset).on('click', function () {
      confirmationDialog();
    });
  }
}

/**
 * Dialog de Confirmação do reset da integração
 * com Conta Azul
 */
function confirmationDialog() {
  bootbox.dialog({
    title: Lang.get('js/src/functions/ResetAccount.configure_another_account'),
    message: Lang.get('js/src/functions/ResetAccount.details_configure_another_account_contaazul'),
    closeButton: false,
    buttons: {
      deny: {
        label: Lang.get('js/src/functions/ResetAccount.no'),
        className: 'btn-danger',
        callback() {
          return true;
        }
      },
      confirm: {
        label: Lang.get('js/src/functions/ResetAccount.yes'),
        className: 'btn-success',
        callback() {
          nifty.body.overlay('show');
          window.location = route('app.settings.integracoes.contaazul.reset-account');
        }
      }
    }
  });
}

module.exports = ResetAccount;
